import React from "react";

export default function ComparativeBoundary() {
  return (
    <section className="rr-delta-boundary">
      <div className="rr-delta-grammar">
        <span>COMPARATIVE</span>
        <span>NOT TEMPORAL</span>
        <span>NOT CAUSAL</span>
        <span>NOT NORMATIVE</span>
      </div>

      <div className="rr-delta-plain-boundary">
        <b>Compare two configurations around the same capability.</b>
        <span>
          Configuration A (K0) and Configuration B (K1) are analytical
          comparison positions — not “before” and “after”.
        </span>
      </div>

      <div className="rr-delta-types">
        <span className="disabled">
          <b>Observed</b>
          <small>not materialized here</small>
        </span>
        <span className="active">
          <b>Comparative</b>
          <small>active lens</small>
        </span>
        <span className="disabled">
          <b>Counterfactual</b>
          <small>not materialized here</small>
        </span>
      </div>
    </section>
  );
}
